export const _socket = state => state.websocket.socket
export const _roomCreatedBy = state =>
    state.websocket.roomStateMsg.room_created_by
export const _roomCreatedByUserId = state => state.websocket.roomStateMsg.master
export const _roomStateMsgData = state => state.websocket.roomStateMsg?.data
export const _chatMessages = state => state.websocket.chatMessages
export const _ttmMsg = state => state.websocket.ttmMsg
export const _isIframeShared = state => state.websocket.isIframeShared
export const _iframeShareUrl = state => state.websocket.iframeShareUrl
export const _websocketMsg = state => state.websocket.msg
export const _websocketNoteMsg = state => state.websocket.noteMsg
export const _websocketChatMsg = state => state.websocket.chatMsg
export const _websocketUserId = state => state.websocket.userId
export const _audioMsg = state => state.websocket.audioMsg
